/* eslint-disable no-shadow */
import { ResultType } from 'Types/common';

export type ViewProps = {
  data: ResultType;
  onClick: () => void;
};

export enum TaxReturnTypes {
  TO_RETURN = 'toReturn',
  TO_PAY = 'toPay',
  EQUAL = 'equal',
  ZERO = 'zero',
}
